import type { ReactNode } from "react";

export function ArrowBackIcon(): ReactNode {
	return (
		<svg
			fill="none"
			height="14"
			viewBox="0 0 14 14"
			width="14"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12.7002 6.7H0.700195M0.700195 6.7L6.1002 12.7M0.700195 6.7L6.1002 0.700005"
				stroke="black"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="1.4"
			/>
		</svg>
	);
}
